<template>
  <div id="app" class="app-container">
    <div class="main-content">
      <Home/>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer'
import Home from '@/components/Home'

export default {
  name: 'InitialView',
  components: {
    Footer,
    Home
  },
  data() {
    return {
      inscricaoAberta: true
    }
  },
  mounted() {
    // Adicionar classe ao body para estilos globais
    document.body.classList.add('home-page')
  },
  beforeDestroy() {
    // Remover classe do body
    document.body.classList.remove('home-page')
  }
}
</script>

<style lang="sass" scoped>
.app-container
  display: flex
  flex-direction: column
  min-height: 100vh
  background: #f8f9fa

.main-content
  flex-grow: 1
  position: relative

/* Estilos globais para a página home */
:global(.home-page)
  overflow-x: hidden

:global(.home-page body)
  margin: 0
  padding: 0
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif

/* Melhorias de performance */
.app-container
  will-change: transform
  backface-visibility: hidden
  transform: translateZ(0)
</style>
